"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      form: {}
    };
  },
  mounted: function mounted() {
    this.getInfo();
  },
  methods: {
    /**
     * 获取信息
     */
    getInfo: function getInfo() {
      var _this = this;
      this.$get('agentapi/get_partner_config', {}).then(function (res) {
        var form = {};
        for (var i = 1; i < 7; i++) {
          form["washing_invest_".concat(i)] = res["washing_invest_".concat(i)];
          form["washing_favourable_".concat(i)] = res["washing_favourable_".concat(i)];
        }
        _this.form = form;
      });
    },
    /**
     * 提交信息
     */
    postEdit: function postEdit() {
      var _this2 = this;
      var params = this.form;
      this.$post('agentapi/system/save_partner_investing_setting', params).then(function (res) {
        _this2.$message({
          message: '提交成功',
          type: 'success'
        });
      });
    }
  }
};